import React from 'react';

import { formatAmountToString } from '../utils/FormatNumber';

interface IEvePriceCalculatorResultsRowProps {
    label: string;
    value: number;
    formatCurrency: (price: string) => string;
}

export const EvePriceCalculatorResultsRow: React.FC<IEvePriceCalculatorResultsRowProps> = props => {
    const { label, value, formatCurrency } = props;
    const className = `eve-price-calculator-display__results`;

    return (
        <div className={`${className}-row`}>
            <div className={`${className}-row--label`}>{label}</div>
            <div className={`${className}-row--value`}>{formatAmountToString(value, formatCurrency)}</div>
        </div>
    );
};
